import { EnvironmentProviders, inject, Injectable, makeEnvironmentProviders } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MatStepperIntl } from '@angular/material/stepper';

import { Observable } from 'rxjs';

import { StepperIntl } from '../material/stepper.intl';
import { TRANSLATION_ADAPTER } from './translation-adapter.token';
import { TranslationAdapter } from './translation-adapter.interface';
import { TranslationDictionary } from '../models/translation-dictionary.type';

@Injectable()
class StaticTranslationAdapter implements TranslationAdapter {
  private httpClient = inject(HttpClient);

  loadTranslations(language: string, scope: string): Observable<TranslationDictionary> {
    return this.httpClient.get<TranslationDictionary>(`/translations/${scope}/${language}.json`);
  }
}

export const provideStaticTranslation = (): EnvironmentProviders => makeEnvironmentProviders([
  { provide: TRANSLATION_ADAPTER, useClass: StaticTranslationAdapter },
  { provide: MatStepperIntl, useClass: StepperIntl },
]);
